/* @ngInject */
export default function DistributorsFilter() {
    return function (items, filteredRegion) {
        const results = [];
        for (let i = 0; i < items.length; ++i) {
            if (items[i].seller === 'Digi-Key' || items[i].seller === 'Arrow' || items[i].seller === 'Mouser' || (items[i].seller === 'TTI' && filteredRegion === 'ASIA')
                || items[i].region.toUpperCase() === filteredRegion) {
                results.push(items[i]);
            }
        }
        return results;
    };
}
